<template>
  <layout title="Новый заказ">
    <order-form
        :invoice="proformaInvoice ? proformaInvoice.data : null"
        :sets="sets.data"
        :companies="companies.data"
        :stages="stages.data">
    </order-form>
  </layout>
</template>

<script>
import Layout from '~/Layouts/Layout'
import OrderForm from '~/Components/Order/OrderForm'

export default {
  components: {
    Layout,
    OrderForm
  },
  props: {
    proformaInvoice: Object,
    sets: Object,
    companies: Object,
    stages: Object
  }
}
</script>
